import type { PayoutBatchesTranslations } from "../interfaces/payoutBatches";

export const payoutBatchesTranslations: PayoutBatchesTranslations = {
  // Page
  page_title: "Pagos por lote",
  page_subtitle: "Sube una hoja con muchos pagos, revísala y ejecútala como una sola operación.",
  action_new_batch: "Nuevo lote",
  action_refresh: "Actualizar",
  action_back_to_list: "Volver a los lotes",
  action_view_file: "Ver archivo original",
  action_download_report: "Descargar reporte",
  action_history: "Historial",
  action_cancel_batch: "Cancelar lote",
  action_revalidate: "Revalidar",
  action_retry_failed: "Reintentar {{count}} fallidas",
  action_retry_failed_one: "Reintentar 1 fallida",
  action_retry_failed_other: "Reintentar {{count}} fallidas",
  action_resume: "Reanudar",
  action_upload_another: "Subir otro archivo",
  action_validate_again: "Validar de nuevo",
  action_close: "Cerrar",
  action_cancel: "Cancelar",
  error_load: "No pudimos cargar el lote.",
  error_retry: "Reintentar",
  error_generic: "Algo salió mal. Inténtalo de nuevo.",
  error_network: "Sin conexión. Revisa tu red e inténtalo de nuevo.",
  not_found_title: "Lote no encontrado",
  not_found_description: "El enlace apunta a un lote que no existe o que no pertenece a tu organización.",

  // List
  org_picker_label: "Organización",
  org_picker_placeholder: "Busca por nombre, correo o id",
  org_picker_loading: "Cargando organizaciones…",
  org_picker_empty: "Sin resultados",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "La búsqueda falló. Inténtalo de nuevo.",
  org_picker_catalog_error: "No pudimos cargar las organizaciones.",
  org_picker_catalog_truncated: "El catálogo está recortado: busca por nombre para llegar a todas.",
  org_picker_global_option: "Todas las organizaciones",
  org_picker_global_hint: "Viendo los lotes de todas las organizaciones.",
  org_picker_org_hint: "Viendo solo los lotes de esta organización.",
  org_picker_required_hint: "Elige la organización a la que pertenece el lote.",
  list_filter_corridor_label: "Corredor",
  list_filter_corridor_all: "Todos los corredores",
  list_filter_status_label: "Estado",
  list_filter_status_all: "Todos los estados",
  kpi_all: "Todos",
  kpi_pending_review: "En revisión",
  kpi_pending_approval: "Por aprobar",
  kpi_executing: "Ejecutando",
  kpi_completed: "Completados",
  kpi_with_errors: "Con errores",
  kpi_closed: "Cerrados",
  list_col_created: "Fecha",
  list_col_organization: "Organización",
  list_col_corridor: "Corredor",
  list_col_rows: "Pagos",
  list_col_debit: "Débito",
  list_col_status: "Estado",
  list_col_file: "Archivo",
  list_rows_progress: "{{selected}} de {{total}}",
  list_expires_in: "Expira en {{time}}",
  list_empty_title: "Sube tu primer lote",
  list_empty_description: "Descarga la plantilla del corredor, llénala con un pago por fila y súbela aquí.",
  list_empty_filtered_title: "Ningún lote coincide",
  list_empty_filtered_description: "Cambia los filtros para ver otros lotes.",
  list_live_updated_at: "Actualizado {{time}}",

  // Setup (create)
  setup_title: "Nuevo lote de pagos",
  setup_subtitle: "Elige de dónde sale el dinero y a qué red va; luego sube la plantilla llena.",
  step_configure: "Configurar",
  step_review: "Revisar",
  step_approval: "Aprobación",
  step_confirm: "Pago",
  setup_organization_label: "Organización",
  setup_org_not_enabled_title: "Esta organización no ve pagos por lote",
  setup_org_not_enabled_text:
    "Sus miembros no tienen el módulo habilitado: otro usuario del equipo Coloca tendrá que aprobar el lote. Puedes habilitarlo en Organizaciones.",
  setup_route_title: "Elige origen y destino",
  setup_route_from: "Desde",
  setup_route_to: "Hacia",
  setup_wallet_placeholder: "Elige la wallet que se debita",
  setup_wallet_loading: "Cargando wallets…",
  setup_wallet_empty: "Esta organización no tiene wallets activas.",
  setup_wallet_frozen: "Congelada",
  setup_wallet_available: "Disponible {{amount}}",
  setup_wallet_required: "Elige la wallet de la que sale el dinero.",
  setup_corridor_placeholder: "Elige país y red",
  setup_corridor_description: "Un lote paga por una sola red. La plantilla cambia según la red elegida.",
  setup_corridor_unavailable: "No disponible",
  setup_corridor_required: "Elige a qué país y red van los pagos.",
  setup_template_title: "Descarga y llena la plantilla",
  setup_file_title: "Sube el archivo lleno",
  setup_step_done: "Listo",
  setup_concept_label: "Concepto",
  setup_concept_description: "Opcional. Se usa en las filas que dejen el concepto vacío.",
  setup_concept_placeholder: "Nómina septiembre",
  setup_cross_currency_title: "Conversión incluida",
  setup_cross_currency_text:
    "Tu wallet en {{source}} se convierte a {{currency}} dentro de cada pago. Al validar verás una tasa indicativa; la tasa final se fija al ejecutar, dentro de la tolerancia configurada.",
  setup_submit: "Subir y validar",
  setup_submit_hint: "Te pediremos tu código de verificación.",
  setup_submitting: "Subiendo…",
  setup_two_factor_required: "Activa la autenticación en dos pasos para subir lotes de pagos.",
  setup_upload_error_title: "No pudimos aceptar el archivo",
  setup_upload_archive_failed: "No pudimos guardar el archivo. Inténtalo de nuevo en un momento.",
  template_title: "Plantilla {{rail}}",
  template_description:
    "Un pago por fila. El monto es lo que recibe el beneficiario; las comisiones se calculan encima.",
  template_download: "Descargar plantilla",
  template_downloading: "Descargando…",
  template_need_corridor: "Elige origen y destino para descargar su plantilla.",
  template_error: "No pudimos descargar la plantilla.",
  dropzone_instruction: "Haz clic para subir el lote o arrástralo aquí",
  dropzone_instruction_drop: "Suelta el archivo aquí",
  dropzone_helper: "Usa la plantilla del corredor: un pago por fila.",
  dropzone_constraints: "Máximo {{max}} MB · .xlsx o .csv",
  dropzone_change: "Cambiar",
  dropzone_remove: "Quitar",
  dropzone_file_size: "{{size}} KB",
  file_error_too_large: "El archivo pesa {{size}} MB; el máximo es {{max}} MB.",
  file_error_unsupported_type: "Solo aceptamos .xlsx o .csv.",
  file_error_required: "Sube el archivo del lote.",

  // How it works
  guide_open: "¿Cómo funciona?",
  guide_title: "Cómo funcionan los pagos por lote",
  guide_description: "Del archivo al último pago, en seis pasos.",
  guide_progress: "Paso {{current}} de {{total}}",
  guide_go_to_step: "Ir al paso {{step}}: {{title}}",
  guide_previous: "Anterior",
  guide_next: "Siguiente",
  guide_done: "Entendido",
  guide_route_title: "Elige origen y destino",
  guide_route_body:
    "Escoge la wallet de la que sale el dinero y el país y la red por donde llega. Un lote paga por una sola red; si la wallet está en otra moneda, la conversión va incluida en cada pago.",
  guide_template_title: "Llena la plantilla",
  guide_template_body:
    "Descarga la plantilla de esa red y escribe un pago por fila. El monto es lo que recibe cada persona; las comisiones se calculan encima.",
  guide_upload_title: "Sube el archivo",
  guide_upload_body:
    "Súbelo con tu código de verificación. Revisamos cada fila en segundo plano y te mostramos cuáles están listas y cuáles tienen errores o avisos.",
  guide_review_title: "Revisa el lote",
  guide_review_body:
    "Ves cuánto se debita, las comisiones y tu saldo. Las filas con errores no se pagan y puedes quitar las que no quieras; luego lo envías a aprobación.",
  guide_review_body_self:
    "Ves cuánto se debita, las comisiones y tu saldo. Las filas con errores no se pagan y puedes quitar las que no quieras; luego lo apruebas tú.",
  guide_approval_title: "Otra persona lo aprueba",
  guide_approval_body:
    "Otro usuario con permiso de aprobación, distinto a quien lo subió o lo envió, lo revisa y lo paga con su código. También puede devolvértelo con un motivo. Si nadie lo aprueba a tiempo, el lote vence.",
  guide_self_approval_title: "Lo apruebas tú",
  guide_self_approval_body_org_setting:
    "Tu organización activó la autoaprobación: lo apruebas y lo pagas tú con tu código. Si prefieres que otra persona lo revise, envíalo a aprobación. En el historial queda marcado como aprobado sin segundo aprobador.",
  guide_self_approval_body_sole_approver:
    "Eres la única persona de tu organización que puede aprobar lotes, así que lo apruebas y lo pagas tú con tu código, sin enviárselo a nadie. En el historial queda marcado como aprobado sin segundo aprobador.",
  guide_approval_settings_link: "Cómo se aprueba en tu organización",
  guide_run_title: "Sigue los pagos",
  guide_run_body:
    "Los pagos salen uno a uno y ves el avance en vivo. Al final descargas el reporte y puedes reintentar los que fallen.",
  guide_scene_file: "nomina.xlsx",
  guide_scene_approver: "Aprobador",
  guide_scene_self_approver: "Tú, con tu código",

  // Statuses
  status_batch_uploaded: "Subido",
  status_batch_validating: "Validando",
  status_batch_validation_failed: "Validación fallida",
  status_batch_ready: "En revisión",
  status_batch_pending_approval: "Por aprobar",
  status_batch_approved: "Aprobado",
  status_batch_executing: "Ejecutando",
  status_batch_completed: "Completado",
  status_batch_completed_with_errors: "Completado con errores",
  status_batch_failed: "Fallido",
  status_batch_cancelled: "Cancelado",
  status_batch_expired: "Expirado",
  status_item_pending: "Pendiente",
  status_item_invalid: "Con errores",
  status_item_excluded: "Excluida",
  status_item_selected: "Seleccionada",
  status_item_queued: "En cola",
  status_item_processing: "Procesando",
  status_item_submitted: "Enviada",
  status_item_paid: "Pagada",
  status_item_failed: "Fallida",
  status_item_reversed: "Revertida",
  status_item_cancelled: "Cancelada",

  // Detail
  detail_created_at: "Creado",
  detail_created_by: "Creado por",
  detail_corridor: "Corredor",
  detail_file: "Archivo",
  detail_rows: "{{count}} filas",
  detail_rows_one: "1 fila",
  detail_rows_other: "{{count}} filas",
  detail_updated_at: "Actualizado {{time}}",
  detail_live: "en vivo",
  detail_polling: "cada {{seconds}} s",
  validating_title: "Validando {{count}} filas…",
  validating_description:
    "Revisamos cada destino, monto y límite, buscamos duplicados y calculamos el costo. Esta pantalla se actualiza sola.",
  validation_failed_title: "No pudimos validar el lote",
  validation_failed_description: "Corrige el archivo y súbelo de nuevo, o cancela este lote.",
  validation_failed_description_revalidate:
    "Corrige el archivo y súbelo de nuevo, o cancela este lote. Si la causa ya se resolvió fuera del archivo (por ejemplo, la verificación de la organización), valídalo de nuevo.",
  expiry_banner: "Este lote expira en {{time}}. Después habrá que subirlo de nuevo.",
  expiry_expired: "El lote expiró antes de confirmarse.",
  warning_same_file_link: "Ver el lote anterior",
  warning_fees_updated_title: "Las comisiones cambiaron desde la última validación",
  warning_fees_updated_text:
    "Recalculamos los precios del lote con la tarifa vigente. Revisa el nuevo débito antes de confirmar.",
  warning_fees_updated_fees: "Comisiones",
  warning_fees_updated_debit: "Débito total",
  warning_fees_updated_before: "Antes",
  warning_fees_updated_after: "Ahora",
  cancel_title: "Cancelar el lote",
  cancel_description: "No se pagará ninguna fila. Puedes subir el archivo de nuevo cuando quieras.",
  cancel_reason_label: "Motivo",
  cancel_reason_placeholder: "Opcional: por qué se cancela",
  cancel_confirm: "Cancelar lote",
  cancel_success: "Lote cancelado.",
  events_title: "Historial del lote",
  events_description: "Cada acción y cada cambio de estado, con quién lo hizo.",
  events_empty: "Todavía no hay eventos.",
  events_error: "No pudimos cargar el historial.",
  events_load_more: "Cargar más",
  event_meta_code: "Código",
  event_meta_run: "Corrida {{run}}",
  event_meta_rows: "{{count}} filas",
  event_meta_reason: "Motivo",
  event_meta_self_approved: "Sin segundo aprobador",
  event_meta_self_approval_org_setting: "autoaprobación activada",
  event_meta_self_approval_sole_approver: "única persona que podía aprobar",
  event_reason_fees_changed: "cambiaron las comisiones",
  event_type_batch_uploaded: "Lote subido",
  event_type_file_archived: "Archivo archivado",
  event_type_validation_started: "Validación iniciada",
  event_type_validation_finished: "Validación terminada",
  event_type_validation_failed: "Validación fallida",
  event_type_item_excluded: "Fila excluida",
  event_type_item_included: "Fila incluida",
  event_type_selection_changed: "Selección cambiada",
  event_type_revalidation_requested: "Revalidación pedida",
  event_type_submitted_for_approval: "Enviado a aprobación",
  event_type_approval_rejected: "Devuelto por el aprobador",
  event_type_submission_withdrawn: "Retirado de aprobación",
  event_type_approved: "Lote aprobado",
  event_type_provider_balance_acknowledged: "Liquidez del corredor reconocida",
  event_type_execution_enqueued: "Ejecución encolada",
  event_type_execution_enqueue_failed: "No se pudo encolar la ejecución",
  event_type_execution_started: "Ejecución iniciada",
  event_type_item_processing: "Fila en proceso",
  event_type_item_submitted: "Fila enviada",
  event_type_item_paid: "Fila pagada",
  event_type_item_failed: "Fila fallida",
  event_type_item_reversed: "Fila revertida",
  event_type_item_status_synced: "Estado de fila actualizado por la red",
  event_type_batch_halted: "Lote detenido",
  event_type_execution_finished: "Ejecución terminada",
  event_type_execution_failed: "Ejecución fallida",
  event_type_retry_requested: "Reintento pedido",
  event_type_run_resumed: "Ejecución reanudada",
  event_type_cancelled: "Lote cancelado",
  event_type_expired: "Lote expirado",
  event_type_stall_resumed: "Ejecución retomada tras una pausa",
  event_type_alert_sent: "Alerta enviada",
  actor_system: "Sistema",
  actor_provider: "Red de pago",
  actor_coloca_team: "Equipo Coloca",
  actor_you: "Tú",
  actor_member: "Usuario",

  // Review
  review_title: "Revisa el lote",
  review_subtitle: "Confirma qué filas se pagan y cuánto se debita antes de continuar.",
  balance_title: "Saldo de la wallet",
  balance_available: "Disponible",
  balance_debit: "Débito del lote",
  balance_remaining: "Quedaría",
  balance_sufficient: "Alcanza para pagar las filas seleccionadas",
  balance_insufficient: "No alcanza para las filas seleccionadas",
  balance_unknown: "No pudimos leer el saldo",
  balance_frozen: "La wallet está congelada: no se pueden ejecutar pagos",
  liquidity_title: "Liquidez del corredor {{corridor}}",
  liquidity_ok: "Suficiente",
  liquidity_insufficient: "Insuficiente",
  liquidity_stale: "Desactualizada",
  liquidity_unavailable: "No disponible",
  liquidity_unsupported: "Sin lectura para esta red",
  liquidity_available: "Disponible {{amount}}",
  totals_title: "Este lote",
  totals_payments: "{{count}} pagos",
  totals_payments_one: "1 pago",
  totals_payments_other: "{{count}} pagos",
  totals_receive: "Reciben los beneficiarios",
  totals_fees: "Comisiones",
  totals_debit: "Débito indicativo",
  totals_rate: "Tasa indicativa",
  totals_priced_at: "Cotizado {{time}}",
  totals_fx_notice: "La tasa final se fija al ejecutar cada pago, dentro de la tolerancia configurada.",
  suggestions_title: "El saldo no alcanza",
  suggestions_description: "Elige una forma de ajustar la selección al saldo disponible, o carga la wallet.",
  suggestion_keep_file_order: "Respetar el orden del archivo",
  suggestion_smallest_first: "Pagar la mayor cantidad de filas",
  suggestion_largest_first: "Pagar el mayor monto",
  suggestion_meta: "{{count}} pagos · débito {{debit}} · quedan {{remaining}}",
  suggestion_apply: "Aplicar",
  items_filter_all: "Todas",
  items_filter_selected: "Seleccionadas",
  items_filter_errors: "Con errores",
  items_filter_warnings: "Con advertencias",
  items_filter_excluded: "Excluidas",
  items_filter_processing: "Procesando",
  items_filter_submitted: "Enviadas",
  items_filter_paid: "Pagadas",
  items_filter_failed: "Fallidas",
  items_filter_reversed: "Revertidas",
  items_select_all_valid: "Seleccionar válidas",
  items_deselect_all: "Quitar selección",
  items_exclude_with_warnings: "Excluir con advertencias",
  items_select_page: "Seleccionar las filas de esta página",
  items_select_row: "Seleccionar la fila {{row}}",
  items_col_row: "#",
  items_col_beneficiary: "Beneficiario",
  items_col_receive: "Recibe",
  items_col_fee: "Comisión",
  items_col_debit: "Débito",
  items_col_rate: "Tasa",
  items_col_status: "Estado",
  items_col_issues: "Incidencias",
  items_col_reason: "Motivo",
  items_col_payout: "Pago",
  items_empty_title: "Ninguna fila coincide",
  items_empty_description: "Cambia el filtro para ver otras filas del lote.",
  items_syncing: "Guardando la selección…",
  items_errors_count: "{{count}} errores",
  items_errors_count_one: "1 error",
  items_errors_count_other: "{{count}} errores",
  items_warnings_count: "{{count}} advertencias",
  items_warnings_count_one: "1 advertencia",
  items_warnings_count_other: "{{count}} advertencias",
  row_drawer_title: "Fila {{row}}",
  row_errors_title: "Errores",
  row_warnings_title: "Advertencias",
  row_pricing_title: "Costo del pago",
  row_raw_title: "Datos del archivo",
  row_destination_title: "Destino",
  row_payout_link: "Ver el pago",
  row_batch_link: "Ver el otro lote",
  row_no_pricing: "Sin costo calculado",
  row_attempt: "Intento {{attempt}}",
  row_beneficiary_unknown: "Sin nombre",
  destination_label_pix: "Llave PIX ({{type}})",
  destination_label_spei: "CLABE",
  destination_label_cbu_cvu: "{{type}}",
  destination_label_breb: "Llave Bre-B ({{type}})",
  destination_label_transfiya: "Cuenta {{type}}",
  destination_label_pse: "Cuenta {{type}}",
  destination_label_usdt: "Dirección {{type}}",
  destination_label_unknown: "Destino",
  destination_label_breb_phone: "Llave Bre-B · celular",
  destination_label_breb_email: "Llave Bre-B · correo",
  destination_label_breb_alphanum: "Llave Bre-B · alfanumérica",
  destination_label_breb_nric: "Llave Bre-B · documento",
  destination_label_breb_merchant: "Llave Bre-B · comercio",
  row_beneficiary_from_directory: "Nombre que reporta el directorio Bre-B",
  row_directory_title: "Directorio Bre-B",
  row_directory_found: "La llave existe en el directorio y puede recibir.",
  row_directory_holder: "Titular",
  row_directory_holder_missing: "El directorio no da el nombre",
  row_directory_bank: "Entidad",
  row_directory_checked_at: "Consultado",
  footer_summary: "{{count}} pagos · débito {{debit}}",
  footer_submit: "Enviar a aprobación",
  footer_submit_hint: "Otro usuario con permiso de aprobación lo revisará y lo pagará.",
  footer_approve_hint: "Lo apruebas tú con tu código: no necesita una segunda aprobación.",
  footer_approve_or_submit_hint:
    "Puedes aprobarlo tú con tu código o enviarlo a otra persona para que lo apruebe.",
  footer_blocked_no_write: "Solo lectura: no tienes permiso para preparar lotes.",
  approval_footer_approver_hint:
    "Revisa las filas y el débito. Al aprobar se paga exactamente esta selección.",
  approval_footer_maker_hint: "Esperando que otro usuario con permiso de aprobación lo apruebe.",
  approval_footer_self_approver_hint: "Puedes aprobarlo tú con tu código, o retirarlo para editarlo.",
  approval_footer_reader_hint: "Esperando aprobación.",
  action_approve: "Aprobar y pagar",
  action_reject: "Devolver",
  action_withdraw: "Retirar para editar",
  submit_title: "Enviar a aprobación",
  submit_description:
    "Otra persona con permiso de aprobación revisará este lote y lo pagará con su código de verificación.",
  submit_rows_label: "Pagos",
  submit_debit_label: "Débito estimado",
  submit_frozen_note:
    "Mientras espera, la selección queda congelada. Si necesitas cambiarla, retíralo de aprobación. El lote sigue venciendo a la misma hora.",
  submit_confirm: "Enviar a aprobación",
  submit_success: "Lote enviado a aprobación",
  approval_banner_title: "Esperando aprobación",
  approval_banner_text_self:
    "Lo enviaste el {{when}}. La selección está congelada hasta que otro usuario lo apruebe o te lo devuelva.",
  approval_banner_text_self_approver:
    "Lo enviaste el {{when}}. La selección está congelada hasta que se apruebe o se devuelva, y puedes aprobarlo tú.",
  approval_banner_settings_link: "Cómo se aprueba en tu organización",
  approval_banner_text_other:
    "Enviado a aprobación el {{when}}. La selección está congelada hasta que se apruebe o se devuelva.",
  returned_banner_title: "El aprobador devolvió este lote ({{when}})",
  returned_banner_text: "Ajusta la selección si hace falta y envíalo de nuevo a aprobación.",
  reject_title: "Devolver el lote",
  reject_description:
    "No se paga nada. El lote vuelve a revisión con la misma selección y quien lo envió verá tu motivo.",
  reject_reason_label: "Motivo",
  reject_reason_placeholder: "Ej.: la fila 12 paga a una cuenta equivocada",
  reject_reason_hint: "Mínimo {{count}} caracteres.",
  reject_confirm: "Devolver",
  reject_success: "Lote devuelto a revisión",
  withdraw_title: "¿Retirar de aprobación?",
  withdraw_description:
    "El lote vuelve a revisión con la misma selección para que puedas editarlo. Tendrás que enviarlo de nuevo.",
  withdraw_confirm: "Retirar",
  withdraw_success: "Lote retirado de aprobación",
  footer_blocked_insufficient: "El saldo no alcanza para las filas seleccionadas.",
  footer_blocked_syncing: "Guardando la selección…",
  footer_blocked_expired: "El lote expiró.",
  footer_blocked_none: "Selecciona al menos una fila.",
  footer_blocked_blockers: "El lote tiene bloqueos que impiden ejecutarlo.",

  // Execute
  execute_title: "Confirmar el lote",
  execute_description: "Esto es lo que va a pasar cuando confirmes.",
  execute_payments: "{{count}} pagos",
  execute_debit: "Se debita de tu wallet",
  execute_fees: "Comisiones incluidas",
  execute_receive: "Reciben los beneficiarios",
  execute_fx_notice:
    "La tasa es indicativa: cada pago se convierte al ejecutarse. Si la tasa se mueve más de {{pct}}%, esa fila no se paga y queda marcada.",
  execute_fee_notice:
    "Las comisiones se recalculan al ejecutar cada pago. Si el débito de una fila sube más de {{pct}}% respecto a lo revisado, esa fila no se paga y queda marcada.",
  execute_irreversible: "Una vez confirmado, los pagos salen uno a uno y no se pueden detener desde aquí.",
  execute_self_approval_org_setting:
    "Tu organización permite aprobar los lotes propios: este se paga sin una segunda aprobación y queda marcado en su historial.",
  execute_self_approval_sole_approver:
    "Eres la única persona de tu organización que puede aprobar lotes: este se paga sin una segunda aprobación y queda marcado en su historial.",
  execute_ack_liquidity_label: "Entiendo el riesgo de liquidez del corredor",
  execute_ack_liquidity_description:
    "No pudimos confirmar que la red tenga fondos suficientes; algunos pagos podrían quedar en espera.",
  execute_reviewed_label: "Revisé las filas y los montos",
  execute_confirm: "Confirmar y ejecutar",
  execute_arming: "Lee el resumen…",
  execute_sending: "Confirmando…",
  execute_conflict_title: "El lote cambió desde que lo revisaste",
  execute_conflict_description:
    "Alguien modificó la selección o el lote ya no está listo. Vuelve a revisar los datos actualizados antes de confirmar.",
  execute_conflict_back: "Volver a revisar",
  execute_self_approval_revoked_title: "Ya no puedes aprobarlo tú",
  execute_self_approval_revoked_description:
    "Cambió quién puede aprobar lotes en tu organización: ahora debe aprobarlo otra persona con permiso de aprobación.",
  execute_unconfirmed_title: "No pudimos confirmar el resultado",
  execute_unconfirmed_description:
    "Perdimos la conexión después de enviar la confirmación. Estamos releyendo el estado del lote.",
  execute_done_title: "Lote en ejecución",
  execute_done_description: "Los pagos empezaron a salir. Puedes seguir el avance en esta pantalla.",
  execute_busy_description: "Otro lote de esta organización ya está ejecutándose con esta wallet.",
  execute_two_factor_required: "Activa la autenticación en dos pasos para ejecutar lotes de pagos.",
  execute_success_toast: "Lote confirmado. Los pagos están saliendo.",
  error_fingerprint_mismatch: "El lote cambió desde que lo revisaste. Revísalo de nuevo antes de confirmar.",
  approval_uploader_hint:
    "Quien subió o envió el lote a aprobación no puede aprobar sus pagos. Debe hacerlo otro usuario con permiso de aprobación.",
  error_self_approval_forbidden:
    "Quien subió el lote o lo envió a aprobación no puede devolverlo, y solo puede aprobarlo si tu organización lo permite. Debe hacerlo otro usuario con permiso de aprobación.",
  error_not_ready: "El lote no está listo para esta acción.",
  error_nothing_selected: "No hay filas seleccionadas.",
  error_insufficient_funds: "El saldo de la wallet no cubre las filas seleccionadas.",
  error_organization_busy: "Otro lote de esta organización ya está ejecutándose con esta wallet.",
  error_provider_balance_ack_required:
    "La liquidez del corredor no se pudo confirmar; reconócelo para continuar.",
  error_expired: "El lote expiró antes de confirmarse. Súbelo de nuevo.",
  error_retry_debit_exceeded:
    "Las filas reintentadas cuestan más que el monto que aprobaste. Revisa los precios nuevos.",
  error_run_pending:
    "Este lote tiene pagos de una ejecución anterior que aún no se procesaron. Reanúdalo antes de reintentar las filas fallidas.",
  error_retry_rows_changed:
    "Las filas cambiaron desde que calculaste el reintento. Revisa los precios nuevos antes de aprobarlo.",
  error_items_not_retryable: "Solo se pueden reintentar filas fallidas sin un pago en curso.",
  error_invalid_status: "Esta acción no está permitida en el estado actual del lote.",
  error_wallet_frozen: "La wallet de origen está congelada.",
  error_rail_disabled: "Esta red está en mantenimiento por ahora.",
  error_verification_required: "Tu organización debe completar la verificación antes de enviar pagos.",
  error_fees_changed:
    "Las comisiones cambiaron mientras revisabas el lote. Revísalo de nuevo para ver los precios actualizados.",
  error_not_pending_approval: "El lote ya no está esperando aprobación. Recarga para ver su estado.",
  error_not_enabled: "Los pagos por lote no están habilitados para tu organización.",

  // Progress
  progress_title: "Avance del lote",
  progress_legend_paid: "Pagadas",
  progress_legend_failed: "Fallidas",
  progress_legend_submitted: "Enviadas, esperando liquidación",
  progress_legend_processing: "Procesando",
  progress_legend_pending: "Pendientes",
  progress_processed: "{{done}} de {{total}} procesadas",
  counters_pending: "Pendientes",
  counters_processing: "Procesando",
  counters_submitted: "Enviadas",
  counters_paid: "Pagadas",
  counters_failed: "Fallidas",
  counters_reversed: "Revertidas",
  result_completed_title: "Lote completado",
  result_completed_description: "Todas las filas seleccionadas se pagaron.",
  result_completed_with_errors_title: "Lote completado con errores",
  result_completed_with_errors_description:
    "Algunas filas no se pagaron. Revisa el motivo de cada una y reintenta las que correspondan.",
  result_failed_title: "La ejecución falló",
  result_failed_description:
    "Un error del sistema interrumpió el lote. Las filas ya pagadas no se repiten; puedes reanudar las pendientes.",
  result_cancelled_title: "Lote cancelado",
  result_cancelled_description: "No se pagó ninguna fila.",
  result_expired_title: "Lote expirado",
  result_expired_description: "El lote no se confirmó a tiempo. Súbelo de nuevo si sigue vigente.",
  result_halted: "El lote se detuvo por fallos repetidos: {{reason}}.",
  result_executing_title: "Pagos en curso",
  result_executing_description: "Las filas se pagan una a una. Puedes cerrar esta pantalla y volver después.",
  retry_title: "Reintentar filas fallidas",
  retry_description: "Revisa el costo actualizado de cada fila antes de aprobar el reintento.",
  retry_preview_loading: "Calculando precios nuevos…",
  retry_preview_error: "No pudimos calcular los precios nuevos.",
  retry_col_row: "Fila",
  retry_col_new_debit: "Débito nuevo",
  retry_col_issue: "Incidencia",
  retry_total: "Débito total {{amount}}",
  retry_retryable_count: "{{count}} filas se pueden reintentar",
  retry_retryable_count_one: "1 fila se puede reintentar",
  retry_retryable_count_other: "{{count}} filas se pueden reintentar",
  retry_none_retryable: "Ninguna de estas filas se puede reintentar ahora.",
  retry_reviewed_label: "Revisé los precios nuevos",
  retry_confirm: "Aprobar reintento",
  retry_arming: "Lee el resumen…",
  retry_debit_changed: "Los precios volvieron a cambiar. Revisa el total actualizado.",
  retry_resume_first_hint: "Primero reanuda el lote: aún tiene pagos pendientes de la ejecución anterior.",
  retry_two_factor_required: "Activa la autenticación en dos pasos para reintentar pagos.",
  retry_success_toast: "Reintento aprobado. Las filas vuelven a la cola.",
  resume_title: "Reanudar la ejecución",
  resume_description:
    "Las filas que no llegaron a procesarse vuelven a la cola. Las ya pagadas no se repiten.",
  resume_rows: "{{count}} filas pendientes",
  resume_rows_one: "1 fila pendiente",
  resume_rows_other: "{{count}} filas pendientes",
  resume_reviewed_label: "Entiendo qué filas se van a procesar",
  resume_confirm: "Reanudar",
  resume_arming: "Lee el resumen…",
  resume_two_factor_required: "Activa la autenticación en dos pasos para reanudar lotes.",
  resume_success_toast: "Ejecución reanudada.",
  report_downloading: "Preparando el reporte…",
  report_error: "No pudimos descargar el reporte.",
};
